<template>
  <main v-if="notification && notification.data">
    <div @click="$router.go(-1)" class="flex cursor-pointer items-center">
      <div class="p-2 border border-opacity-25 rounded-md border-blue-500">
        <svg
          class="w-5 h-5 fill-current text-blue-500"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.2541 4.24106C16.5522 4.53326 16.5793 4.99051 16.3354 5.31272L16.2541 5.40503L9.52658 12L16.2541 18.595C16.5522 18.8872 16.5793 19.3444 16.3354 19.6666L16.2541 19.7589C15.956 20.0511 15.4896 20.0777 15.161 19.8386L15.0668 19.7589L7.7459 12.582C7.44784 12.2898 7.42074 11.8325 7.66461 11.5103L7.7459 11.418L15.0668 4.24106C15.3947 3.91965 15.9262 3.91965 16.2541 4.24106Z"
          />
        </svg>
      </div>
      <div class="ml-2 text-sm text-black">Back</div>
    </div>
    <h1 class=" text-2xl font-semibold">Preview</h1>
    <div class="flex  justify-center items-center mt-10 w-full">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="113"
        height="25"
        viewBox="0 0 113 25"
        fill="none"
      >
        <path d="M0 13.5958H11.1872V25H0V13.5958Z" fill="#7CCCEB" />
        <path
          d="M0.00366211 11.3906H11.1775V0H0.00366211V11.3906ZM0.00366211 11.3906H11.1775H0.00366211Z"
          fill="#043CAC"
        />
        <path d="M24.5242 11.3906H13.3503V0H24.5242V11.3906Z" fill="#7CCCEB" />
        <path d="M24.5243 13.5958H13.3372V25H24.5243V13.5958Z" fill="#7CCCEB" />
        <path
          d="M39.5025 17.8885C39.1981 18.1173 38.8247 18.2893 38.3814 18.4037C37.9385 18.5185 37.4791 18.5757 37.0027 18.5757C35.7201 18.5757 34.7346 18.2457 34.0471 17.5847C33.3591 16.9242 33.0156 15.9538 33.0156 14.6731V5.12808H36.1101V7.7772H38.7483V10.2036H36.1101V14.6323C36.1101 15.0908 36.2227 15.4447 36.4476 15.6941C36.672 15.9435 36.9962 16.0682 37.4193 16.0682C37.8957 16.0682 38.3188 15.9336 38.689 15.6636L39.5025 17.8885ZM44.2037 8.97027C44.5739 8.44429 45.0733 8.04675 45.7015 7.7772C46.3297 7.50765 47.054 7.37264 47.8739 7.37264V10.2847C47.53 10.2576 47.2986 10.2444 47.1795 10.2444C46.2934 10.2444 45.599 10.4971 45.0963 11.0025C44.5937 11.5083 44.3426 12.2663 44.3426 13.2775V18.414H41.2482V7.53437H44.2037V8.97027ZM60.4504 7.53437V18.414H57.4948V17.1605C56.7278 18.1041 55.6167 18.5757 54.1622 18.5757C53.1569 18.5757 52.2477 18.3465 51.4347 17.8885C50.6212 17.43 49.9829 16.7761 49.5203 15.9266C49.0572 15.0772 48.8259 14.0932 48.8259 12.9742C48.8259 11.8552 49.0572 10.8712 49.5203 10.0218C49.9829 9.17231 50.6212 8.51882 51.4347 8.06035C52.2477 7.60187 53.1569 7.37264 54.1622 7.37264C55.5243 7.37264 56.5889 7.81095 57.3559 8.68712V7.53437H60.4504ZM54.6979 15.9876C55.4778 15.9876 56.1263 15.7143 56.6418 15.1681C57.1577 14.6224 57.4153 13.8911 57.4153 12.9742C57.4153 12.0577 57.1577 11.3259 56.6418 10.7803C56.1263 10.2341 55.4778 9.96128 54.6979 9.96128C53.9042 9.96128 53.2498 10.2341 52.7338 10.7803C52.2183 11.3259 51.9603 12.0577 51.9603 12.9742C51.9603 13.8911 52.2183 14.6224 52.7338 15.1681C53.2498 15.7143 53.9042 15.9876 54.6979 15.9876ZM68.465 18.5757C67.3277 18.5757 66.3059 18.3367 65.3999 17.858C64.494 17.3794 63.7867 16.7151 63.2777 15.8661C62.7681 15.0167 62.5138 14.0529 62.5138 12.9742C62.5138 11.896 62.7681 10.9317 63.2777 10.0822C63.7867 9.23326 64.494 8.56898 65.3999 8.09082C66.3059 7.61219 67.3277 7.37264 68.465 7.37264C69.5889 7.37264 70.5712 7.61219 71.4109 8.09082C72.2506 8.56898 72.8622 9.25341 73.2457 10.1432L70.8452 11.4577C70.2902 10.4601 69.49 9.96128 68.4452 9.96128C67.6386 9.96128 66.9704 10.2308 66.4415 10.7699C65.9127 11.309 65.6483 12.0441 65.6483 12.9742C65.6483 13.9043 65.9127 14.6393 66.4415 15.1784C66.9704 15.7175 67.6386 15.9876 68.4452 15.9876C69.5029 15.9876 70.3031 15.4883 70.8452 14.4907L73.2457 15.8254C72.8622 16.6884 72.2506 17.3625 71.4109 17.8477C70.5712 18.3329 69.5889 18.5757 68.465 18.5757ZM81.379 17.8885C81.075 18.1173 80.7011 18.2893 80.2583 18.4037C79.8154 18.5185 79.3555 18.5757 78.8796 18.5757C77.5965 18.5757 76.6115 18.2457 75.924 17.5847C75.236 16.9242 74.8921 15.9538 74.8921 14.6731V5.12808H77.987V7.7772H80.6252V10.2036H77.987V14.6323C77.987 15.0908 78.0992 15.4447 78.3241 15.6941C78.5489 15.9435 78.8731 16.0682 79.2962 16.0682C79.7722 16.0682 80.1953 15.9336 80.5659 15.6636L81.379 17.8885ZM83.1246 7.53437H86.2195V18.414H83.1246V7.53437ZM84.6721 6.01784C84.1032 6.01784 83.6406 5.84954 83.2837 5.51202C82.9264 5.17543 82.748 4.75727 82.748 4.25848C82.748 3.75969 82.9264 3.34153 83.2837 3.00494C83.6406 2.66788 84.1032 2.49911 84.6721 2.49911C85.2409 2.49911 85.7035 2.66085 86.0609 2.98431C86.4177 3.30777 86.5961 3.71234 86.5961 4.198C86.5961 4.72351 86.4177 5.15855 86.0609 5.50217C85.7035 5.84579 85.2409 6.01784 84.6721 6.01784ZM94.1743 18.5757C93.0499 18.5757 92.0419 18.3367 91.1488 17.858C90.2562 17.3794 89.5586 16.7151 89.0564 15.8661C88.5538 15.0167 88.3023 14.0529 88.3023 12.9742C88.3023 11.896 88.5538 10.9317 89.0564 10.0822C89.5586 9.23326 90.2562 8.56898 91.1488 8.09082C92.0419 7.61219 93.0499 7.37264 94.1743 7.37264C95.2982 7.37264 96.3035 7.61219 97.1897 8.09082C98.0754 8.56898 98.7698 9.23326 99.2724 10.0822C99.775 10.9317 100.026 11.896 100.026 12.9742C100.026 14.0529 99.775 15.0167 99.2724 15.8661C98.7698 16.7151 98.0754 17.3794 97.1897 17.858C96.3035 18.3367 95.2982 18.5757 94.1743 18.5757ZM94.1743 15.9876C94.9676 15.9876 95.6192 15.7143 96.1283 15.1681C96.6374 14.6224 96.8921 13.8911 96.8921 12.9742C96.8921 12.0577 96.6374 11.3259 96.1283 10.7803C95.6192 10.2341 94.9676 9.96128 94.1743 9.96128C93.3806 9.96128 92.7262 10.2341 92.2102 10.7803C91.6947 11.3259 91.4367 12.0577 91.4367 12.9742C91.4367 13.8911 91.6947 14.6224 92.2102 15.1681C92.7262 15.7143 93.3806 15.9876 94.1743 15.9876ZM108.576 7.37264C109.899 7.37264 110.967 7.7772 111.78 8.58586C112.593 9.39499 113 10.5946 113 12.1857V18.414H109.905V12.6709C109.905 11.8078 109.72 11.1642 109.35 10.7399C108.98 10.3152 108.444 10.1029 107.743 10.1029C106.963 10.1029 106.341 10.349 105.878 10.8407C105.415 11.333 105.184 12.0643 105.184 13.0351V18.414H102.09V7.53437H105.045V8.80853C105.455 8.35006 105.964 7.99612 106.573 7.74673C107.181 7.49733 107.849 7.37264 108.576 7.37264Z"
          fill="#043CAC"
        />
      </svg>
    </div>
    <div class="  flex justify-center items-center mt-5 mx-auto ">
      <input
        v-if="notification && notification.data && edit"
        type="text"
        class="border-2 mt-5  border-gray-200 pl-3 py-3 w-3/6 mx-auto"
        v-model="notification.data.title"
      />
      <h1 class="mt-5 font-medium text-2xl capitalize" v-else>
        {{ notification.data.title }}
      </h1>
    </div>

    <div
      v-if="edit"
      class=" border-2  border-gray-200 pl-3 py-3 w-3/6 mx-auto h-96 flex justify-center items-center flex-col mt-8 "
    >
      <svg v-if="loading" class="spinner ml-4 " viewBox="0 0 50 50">
        <circle
          class="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke-width="5"
        ></circle>
      </svg>
      <img
        v-else-if="notification && notification.data && notification.data.url"
        class="h-full w-full object-contain"
        :src="notification.data.url"
        alt=""
      />

      <div v-else>
        No image
      </div>
      <input
        type="file"
        name=""
        id=""
        class="hidden"
        ref="inputFile"
        accept="image/*"
        @change="selectImage"
      />
    </div>
    <div v-else>
      <img
        class="h-96 max-w-3xl mt-10 w-full mx-auto object-contain"
        :src="notification.data.url"
        alt=""
      />
    </div>
    <div
      v-if="edit"
      @click="$refs.inputFile.click()"
      class="text-center text-blue-500 cursor-pointer mt-10"
    >
      Add/Change image
    </div>

    <div class="flex justify-center items-center">
      <textarea
        v-if="edit"
        class="py-4 pl-6 border-2 rounded-md border-gray-200 w-3/6 mx-auto mt-10"
        placeholder="Summary"
        name=""
        id=""
        cols="30"
        rows="10"
        v-model="notification.data.message"
      ></textarea>
      <div v-else class=" max-w-3xl w-full mt-10">
        <p>
          {{ notification.data.message }}
        </p>
      </div>
    </div>
    <div class="flex justify-center flex-col items-center">
      <div>
        <button
          @click="update"
          class="w-80  bg-blue-600 py-5 text-white rounded-md mt-10 mr-4"
        >
          Update and Save
        </button>
        <button
          @click="publish"
          class="w-80  bg-blue-600 py-5 text-white rounded-md mt-10"
        >
          Publish
        </button>
      </div>
      <p
        @click="edit = !edit"
        class="text-sm mt-3 cursor-pointer  text-blue-500 font-bold text-center"
      >
        {{ !edit ? "Edit" : "Preview" }}
      </p>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      edit: false,
      notification: {},
      loading: false,
      imageToUpload: {
        src: null,
        file: null,
      },
    };
  },

  methods: {
    async selectImage(e) {
      this.loading = true;
      this.imageToUpload.file = e.target.files[0];
      this.imageToUpload.src = window.URL.createObjectURL(
        this.imageToUpload.file
      );
      let res = await this.$store.dispatch("UPLOAD_FILE", this.imageToUpload);
      this.notification.data.url = res.data;
      this.loading = false;
    },
    async update() {
      let payload = {
        _id: this.notification._id,
        notificationId: this.notification.notificationId,
        to: "",
        data: {
          title: this.notification.data.title,
          message: this.notification.data.message,
          url: this.notification.data.url || "",
        },
      };
      let res = await this.$store.dispatch("UPDATE_MESSAGE", payload);
      if (res.status) {
        this.$router.push({ name: "Notifications" });
        alert("Message updated succesfully");
      }
    },
    async publish() {
      let payload = {
        notificationId: this.notification.notificationId,
        to: "",
        data: {
          title: this.notification.data.title,
          message: this.notification.data.message,
          url: this.notification.data.url || "",
        },
      };
      let res = await this.$store.dispatch("PUBLISH_MESSAGE", payload);
      if (res.status) {
        this.$router.push({ name: "Notifications" });
        alert("Message published succesfully");
      }
    },
  },
  async mounted() {
    let response = await this.$store.dispatch("GET_ALL_NOTIFICATIONS");

    let data = response.data.find((item) => {
      return item._id === this.$route.params.id;
    });
    this.notification = data;
  },
};
</script>

<style></style>
